import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const FooterContainer = styled.footer<{ colors: any }>`
  background: transparent;
  color: ${props => props.colors.textSecondary};
  font-family: 'Poppins', sans-serif;
  font-size: 0.95rem;
  border-top: none;
  padding: 2.5rem 0;
  margin-top: 0;
  position: relative;
  z-index: 10;
  letter-spacing: 0px;
  pointer-events: auto;
  
  @media (max-width: 1100px) {
    padding-bottom: 120px;
    z-index: 100;
  }
`;

export const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  text-align: center;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const FooterLinks = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 1.5rem;
  
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 12px;
    margin-bottom: 1rem;
  }
`;

export const FooterLink = styled(Link)<{ colors: any }>`
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: ${props => props.colors.primary};
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  z-index: 101;
  pointer-events: auto;
  cursor: pointer;
  
  &:hover {
    color: ${props => props.colors.primaryHover};
    text-decoration: underline;
  }
  
  @media (max-width: 1100px) {
    z-index: 101;
    pointer-events: auto;
  }
`;

export const SocialButtons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
`;

export const SocialButton = styled.a<{ colors: any }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.colors.primary};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  z-index: 101;
  pointer-events: auto;
  cursor: pointer;
  
  svg {
    width: 20px;
    height: 20px;
    fill: white;
  }
  
  &:hover {
    background: ${props => props.colors.primaryHover};
  }
  
  @media (max-width: 1100px) {
    z-index: 101;
    pointer-events: auto;
  }
`;

